import { VitalSignContext } from 'src/app/interfaces/vital-signs/vital-sign-context';

export class VitalSignContextFactory {

  public static fromObject(vitalSignContext: any): VitalSignContext {
    return new class implements VitalSignContext {
      id: number = vitalSignContext.id;
      vitalSignTypeId: number = vitalSignContext.vital_sign_type_id;
      name: string = vitalSignContext.name;
      sort: number = vitalSignContext.sort;
      isActive: boolean = vitalSignContext.is_active;
      created: string = vitalSignContext.created;
      modified: string = vitalSignContext.modified;
      isOther: boolean = vitalSignContext.is_other;
    };
  }

  public static fromArray(vitalSignContexts: any[]): VitalSignContext[] {
    return vitalSignContexts.map(VitalSignContextFactory.fromObject);
  }
}
